import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectIstAngemeldet } from 'core/features/auth/authSlice';

/**
 * Layout-Route: gibt ohne gueltige Anmeldung auf `/login` weiter (merkt sich die
 * urspruenglich gewuenschte Seite), sonst werden die Kind-Routen via <Outlet/> gezeigt.
 */
export default function ProtectedRoute() {
  const istAngemeldet = useSelector(selectIstAngemeldet);
  const location = useLocation();

  if (!istAngemeldet) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <Outlet />;
}
